import React, { createContext } from 'react';

// Create the context
const ThemeContext = createContext();

export default ThemeContext;